var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"com-menu-item",class:{
        'com-menu-item--separator': _vm.separator,
        'com-menu-item--text': !_vm.separator
    },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }